import { Icon } from 'gu-ui-kit'
import React from 'react'
import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'
import { AccountRow, NetworkRow } from 'modules/Statistics/Main/subcomponents/OptionTemplates'

const now = new Date()
const startDate = subWeeks(now, 2)

export default () => {
  return {
    initial: {
      query: '',
      networks: [],
      status: '',
      include_vat: true,
      date_group_period: 'day',
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(now, 'yyyy-MM-dd'),
      account_ids: [],
    },
    configuration: {
      date_group_period: {
        options: ['day', 'week', 'month'],
        subbutton: {
          clearIgnore: true,
        },
      },
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'statistics::filters.input.placeholder',
        placeholder: 'statistics::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      networks: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-11'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.networks.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'statistics::filters.dropdown.items.networks.options.',
        rowRenderComponent: NetworkRow,
        options: ['yandexdirect', 'vk', 'googleads', 'vkads'],
      },
      status: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'statistics::filters.dropdown.items.status.options.',
        options: ['active', 'inactive'],
      },
      account_ids: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'secondary-33'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.accounts.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: '',
        rowRenderComponent: AccountRow,
        options: [],
      },
      datepicker: {
        names: ['date_from', 'date_to'],
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.sm,
        },
        // @todo нужен общий лейбл а не в пульсе
        label: 'pulse::filters.range.label',
        order: 2,
        type: 'datepicker',
      },
      include_vat: {
        order: 2,
        type: 'switcher',
        label: 'statistics::filters.include_vat.label',
        optionLabelPrefix: 'pulse::filters.include_vat.',
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.mds,
          clearIgnore: true,
        },
        options: [true, false],
      },
    },
  }
}
